@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.today_v2.today_ui_pcos.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.today_v2.today_ui_pcos.generated.resources/"

@delegate:ResourceContentHash(-905_031_371)
internal val Res.drawable.ic_plus_50: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus_50", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus_50.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_plus_50", Res.drawable.ic_plus_50)
}
